const defaultPhoneCodes: {[locale: string]: string} = {
    'nl-NL': '+31',
    'fr-BE': '+32',
    'fr-FR': '+33',
    'fr-FR-CSE': '+33',
    'en-US': '+44',
}

export default defaultPhoneCodes